import React from 'react';

import styled from 'styled-components';

type AlertTypeTagScheme = {
  color: string;
  background: string;
};

const DEFAULT_ALERT_TYPE_TAG_SCHEME: AlertTypeTagScheme = {
  color: 'var(--alert-tag-positive-text)',
  background: 'var(--alert-tag-positive-bg)',
};

const ALERT_TYPE_TAG_SCHEMES: Record<string, AlertTypeTagScheme> = {
  incentives: DEFAULT_ALERT_TYPE_TAG_SCHEME,
  pricing: {
    color: 'var(--competitor-purple)',
    background: 'var(--lavender-soft)',
  },
};

const Container = styled.span<{ color: string; backgroundColor: string }>`
  font-size: 12px;
  padding: 6px 10px;
  color: ${({ color }) => color};
  background: ${({ backgroundColor }) => backgroundColor};
`;

const getAlertTypeOrDefaultScheme = (typeName: string) => {
  const normalizedTypeName = typeName.toLowerCase();
  const matchedType = Object.keys(ALERT_TYPE_TAG_SCHEMES).find((key) => normalizedTypeName.includes(key));

  if (!matchedType) {
    return DEFAULT_ALERT_TYPE_TAG_SCHEME;
  }

  return ALERT_TYPE_TAG_SCHEMES[matchedType];
};

type Props = {
  typeName: string;
};

const AlertTypeTag = ({ typeName }: Props) => {
  const scheme = getAlertTypeOrDefaultScheme(typeName);

  return (
    <Container color={scheme.color} backgroundColor={scheme.background}>
      {typeName}
    </Container>
  );
};

export default AlertTypeTag;
